<template>
    <div><!-- 試作準備 -->
        <SearchBar @trialQueryEvent="doTrialSearch" @trialExportEvent="doTrialExport"/>
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                            <th class="text-center">{{headers[9]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in trialSearchResult" :key="index">
                            <td class="text-center">{{item.factoryName}}</td>
                            <td class="text-center">{{item.roeModel}}</td>
                            <td class="text-center">{{item.project}}</td>
                            <td>
                               <router-link v-if="isDevelopPhaseLink(item.t0Date)" @click.native="goDevelopPhaseEvent(item, 'T0')" to="">T0</router-link>
                               <span v-else>T0</span> <br>
                               <span>{{fixDate(item.t0Date)}}</span>
                            </td>
                            <td>
                               <router-link v-if="isDevelopPhaseLink(item.esDate)" @click.native="goDevelopPhaseEvent(item, 'ES')" to="">ES</router-link>
                               <span v-else>ES</span> <br>
                               <span>{{fixDate(item.esDate)}}</span>
                            </td>
                            <td>
                               <router-link v-if="isDevelopPhaseLink(item.csDate)" @click.native="goDevelopPhaseEvent(item, 'CS')" to="">CS</router-link>
                               <span v-else>CS</span> <br>
                               <span>{{fixDate(item.csDate)}}</span>
                            </td>
                            <td>
                               <router-link v-if="isDevelopPhaseLink(item.mpDate)" @click.native="goDevelopPhaseEvent(item, 'MP')" to="">MP</router-link>
                               <span v-else>MP</span> <br>
                               <span>{{fixDate(item.mpDate)}}</span>
                            </td>                            
                            <td class="text-center">{{item.uploadShowTxt}}</td>
                            <td class="text-center">{{item.finishShowTxt}}</td>
                            <td class="text-center">{{item.totalItemCount}}</td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import SearchBar from './SearchBar'
import { mapGetters } from 'vuex'
export default {
    components: {
        SearchBar,
    },
    mixins: [qualityMixin],	
    data() {
        return {       
            headers :[
                this.i18n('TrialProduction.Factory'),this.i18n('TrialProduction.Machine'),this.i18n('TrialProduction.ProjectName'),this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.Phase'),
                this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.DegreeOfAction'),this.i18n('TrialProduction.DegreeOfCompletion'),this.i18n('TrialProduction.QuantityToBeCompleted')
            ],
            trialSearchResult: []
        }
    },
    props : {
    },
    watch: {
        "lang":function() {
            this.headers = [
                this.i18n('TrialProduction.Factory'),this.i18n('TrialProduction.Machine'),this.i18n('TrialProduction.ProjectName'),this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.Phase'),
                this.i18n('TrialProduction.Phase'),this.i18n('TrialProduction.DegreeOfAction'),this.i18n('TrialProduction.DegreeOfCompletion'),this.i18n('TrialProduction.QuantityToBeCompleted')
            ]
        }
    },
    methods: {        
        doTrialSearch (param){           
            const url = `${this.$apiUrl_Quality}/SearchTrial`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    const rows = response.data;
                    // if(rows && rows.length >0){
                    //     rows.forEach(r => {
                    //         r.uploadShowTxt = '';
                    //         r.finishShowTxt = '';
                    //     });
                    // }
                    this.trialSearchResult = rows;
                    this.setCacheQueryParam('Trial_QueryParam' , param);                           
                }                    
            }); 
        },
        doTrialExport(param){            
            const url = `${this.$apiUrl_Quality}/PrepareSearchTrialExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchTrialExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('trialExportExcel',urlExcel);
            })
        },
        isDevelopPhaseLink (v){
            if(v){
                return true;    
            }
            return false;
        },
        goDevelopPhaseEvent (item , phase){
            let trialKeys = '';
            if(phase === 'T0'){
                trialKeys = item.t0key;
            }else if(phase === 'ES'){
                trialKeys = item.eskey;
            }else if(phase === 'CS'){
                trialKeys = item.cskey;
            }else if(phase === 'MP'){
                trialKeys = item.mpkey;
            }
            trialKeys += '\t';
            sessionStorage.setItem('trialKeys', trialKeys);
            this.$router.push('information');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.table th {
    background-color: #303c50;
    color: #fff;
}
</style>